import React from 'react';

interface Props {
  width?: number;
  color?: string;
}

const Computer = ({ width = 20, color = '#D4D8E4' }: Props) => (
  <svg width={width} viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1" fill={color}>
      <rect width="20" height="14" rx="1" stroke="none" fill="white" />
    </mask>
    <rect
      width="20"
      height="14"
      rx="1"
      stroke={color}
      fill="none"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-inside-1)"
    />
    <path d="M10 13V16" stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 16H13" stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 11L19 11" stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Computer;
